module.exports = __webpack_public_path__ + "static/media/software_version_inactive.07ef76ce.svg";